<div class="row" *ngIf="data">
  <!-- Total URLs -->
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-info card-header-icon">
        <div class="card-icon">
          <i class="material-icons">link</i>
        </div>
        <p class="card-category">Total URLs</p>
        <h3 class="card-title">{{ data.totalUrls }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons text-info">info</i> In Sitemap
        </div>
      </div>
    </div>
  </div>

  <!-- Missing -->
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-danger card-header-icon">
        <div class="card-icon">
          <i class="material-icons">link_off</i>
        </div>
        <p class="card-category">Missing</p>
        <h3 class="card-title">{{ data.missingCount }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons">error_outline</i> Not found
        </div>
      </div>
    </div>
  </div>

  <!-- Unexpected -->
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-warning card-header-icon">
        <div class="card-icon">
          <i class="material-icons">help_outline</i>
        </div>
        <p class="card-category">Unexpected</p>
        <h3 class="card-title">{{ data.unexpectedCount }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons">warning</i> Out of scope
        </div>
      </div>
    </div>
  </div>

  <!-- Issues -->
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-warning card-header-icon">
        <div class="card-icon">
          <i class="material-icons">bug_report</i>
        </div>
        <p class="card-category">Issues</p>
        <h3 class="card-title">{{ data.issuesCount }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons">priority_high</i> Needs fix
        </div>
      </div>
    </div>
  </div>

  <!-- HTTP Status -->
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-success card-header-icon">
        <div class="card-icon">
          <i class="material-icons">http</i>
        </div>
        <p class="card-category">Status</p>
        <h3 class="card-title" [ngClass]="statusClass">{{ data.status || 'N/A' }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons">public</i> HTTP status
        </div>
      </div>
    </div>
  </div>

  <!-- Last Run -->
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-info card-header-icon">
        <div class="card-icon">
          <i class="material-icons">event</i>
        </div>
        <p class="card-category">Last Run</p>
        <h3 class="card-title" style="font-size: 1rem">{{ data.lastAuditDate | date:'shortTime' }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons">history</i> {{ data.lastAuditDate | date:'MM/dd/yyyy' }}
        </div>
      </div>
    </div>
  </div>
</div>
